import { render, staticRenderFns } from "./CaseActions.vue?vue&type=template&id=47223e47&scoped=true&"
import script from "./CaseActions.vue?vue&type=script&lang=js&"
export * from "./CaseActions.vue?vue&type=script&lang=js&"
import style0 from "./CaseActions.vue?vue&type=style&index=0&id=47223e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47223e47",
  null
  
)

export default component.exports